import React, { useEffect, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import config from "../../../../config/config";
import { toastError, toastSuccess } from "../../../../common/Toast";
import {
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  ERROR_EXISTS,
  CUSTOM_SELECT_DROPDOWN_STYLE,
  AWS_IMAGE_FOLDER_TAGS,
} from "../../../../common/Constant";
import DeleteConfirmationModal from "../../../../components/Modal/DeleteConfirmation";
import Loader from "../../../../components/Loader/Loader";
import { checkUserPermission } from "../../../../common/UserPermission";
import Select from "react-select";

//MUI Table
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { MenuItem } from "@mui/material";
import InventorySubModulesRecordsModal from "../../../../components/Modal/InventorySubModulesRecordsModal";
import CommonMatrialReactTable from "../../../../components/Datatable/CommonMatrialReactTable";
import { uploadAWS } from "../../../../common/AWSHelper";
import { Noimage } from "../../../../common/imagePath";
let PERMISSION_ADD = "add-tags";
let PERMISSION_EDIT = "edit-tags";
let PERMISSION_DELETE = "delete-tags";

const Tags = (props) => {
  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");
  const [formValues, setFormValues] = useState({
    ID: 0,
    Name: "",
    TagType: "",
    TagImageUrl: "",
    Description:"",
  });
  const [searchtext, setSearchText] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [perPage, setPerPage] = useState(10);
  const [sortingId, setSortingId] = useState(4);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [selectedOption, setSelectedOption] = useState(null);
  const validationSchema = Yup.object().shape({
    Name: Yup.string().required("Tag name is required"),
  });
  const [editModalOpen, setEditModalOpen] = useState(false);
  //----------------Server-Side------------------//
  const [runApi, setRunApi] = useState(false);
  const [tagName, setTagName] = useState("");
  const [moduleID, setModuleId] = useState(0);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });
  const [open, setOpen] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]);
  const [rowSelectData, setRowSelectData] = useState([]);
  const [rowSelection, setRowSelection] = useState({});
  const [previewImage, setPreviewImage] = useState("");
  const [selectedImage, setSelectedImage] = useState("");
  const [ImageUrl, setImageUrl] = useState("");
  const [tagDescription, setTagDescription] = useState("");
  const [showLoaderUploadImage, setShowLoaderUploadImage] = useState(false);
  const [btnLoader, setBtnLoader] = useState({ Imagename: false });

  useEffect(() => {
    const result = Object.keys(rowSelection).map(Number);
    setRowSelectData(result);
  }, [rowSelection]);

  const _handleFileChange = (e) => {
    console.log(e.target.files[0], "imageUpload");

    const file = e.target.files[0];
    setSelectedImage(file);

    if (file) {
      // Display a preview of the selected image
      setPreviewImage(URL.createObjectURL(file));
      const reader = new FileReader();
      reader.onload = (event) => {
        setPreviewImage(event.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  //dropdown options
  const options = [
    { value: "Account", label: "Account" },
    { value: "Portal", label: "Portal" },
  ];

  // Get all tag data
  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder
  ) => {
    setLoading(true);
    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";
    console.log(
      JSON.stringify(columnFilters) + " columnFilters | ",
      globalFilter + " globalFilter | ",
      pagination.pageIndex + " pagination.pageIndex | ",
      pagination.pageSize + " pagination.pageSize | ",
      columnIndex,
      sorting[0]?.id,
      sorting[0]?.desc === undefined
        ? "desc"
        : (sorting[0]?.desc === true ? "desc" : "asc") + " sorting | ",
      "api Call payload"
    );

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return {
        columnname: el.id,
        value: el.value,
        id: index + 1,
      };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);
    axios
      .get(
        `${
          config.tagBaseUrl
        }/tags?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex}&pagesize=${
          pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
          globalFilter === undefined ? "" : globalFilter
        }`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setData(res.data.ResponseData);
        setRowCount(res.data.ResponseData[0]?.TotalRecord);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  console.log(data);
  useEffect(() => {
    handleListData(1, perPage, searchtext, sortingId, sortingDirection);
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
  ]);

  const handleUpdate = (pID) => {
    setLoading(true);
    axios
      .get(`${config.tagBaseUrl}/tags/findbyid?id=${pID}`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        const tagData = res.data.ResponseData[0];
        console.log(tagData);

        const data = {
          ID: tagData.ID,
          Name: tagData.Name,
          TagType: tagData.TagType,
          TagImageUrl: tagData.ImageUrl,
          Description: tagData.Description,
        };
        setFormValues(data);
        setPreviewImage(data.TagImageUrl);
        setImageUrl(data.TagImageUrl);

        setSelectedOption(
          options.find((option) => option.value === tagData.TagType)
        );
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const validation = (name, value) => {
    console.log(value, "value");
    switch (name) {
      case "Imagename":
        if (!value.name.match(/\.(jpg|jpeg|png|gif|webp|mp4)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };
  let uploadImageUrlArray = [];
  console.log(ImageUrl, "ImageUrl");
  const uploadFile = async (file, type, event) => {
    setShowLoaderUploadImage(true);
    setBtnLoader({ [type]: true });
    await uploadAWS(file, AWS_IMAGE_FOLDER_TAGS, (data) => {
      if (data) {
        setImageUrl(data);
        uploadImageUrlArray.push(data);
        setShowLoaderUploadImage(false);
        handleSubmit(data, event);
      }
    });
  };

  const handleSubmit = async (data, event) => {
    try {
      setLoading(true);
      const tagImageUrl = data || ImageUrl; // Use new image URL or fallback to existing ImageUrl

      const response = await axios.post(
        `${config.tagBaseUrl}/tags/upsert`,
        {
          id: formValues.ID,
          ecommerecetagid: "",
          name: formValues.Name,
          tagtype: selectedOption.value,
          loginuserid: loginUserId,
          TagImageUrl: tagImageUrl, // Use the selected or existing image URL
          Description: formValues.Description,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      );

      if (response.data.ResponseCode === "SUCCESS") {
        toastSuccess(SUCCESS_MESSAGE);
        setEditModalOpen(false);
        setLoading(false);
        window.location.reload();
      } else if (
        response.data.ResponseCode === "ERROR" &&
        response.data.ResponseID === -1
      ) {
        toastError(ERROR_EXISTS);
        setLoading(false);
      } else {
        toastError(ERROR_MESSAGE);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toastError(ERROR_MESSAGE);
      setLoading(false);
    }
  };

  const handlesubmit1 = async (event) => {
    console.log(selectedImage, "value88888");

    // If a new image is selected
    if (selectedImage) {
      if (validation("Imagename", selectedImage)) {
        await uploadFile(selectedImage, "Imagename", event);
      }
    } else {
      // If no new image is selected, use the existing ImageUrl
      console.log(event, "event");
      await handleSubmit(ImageUrl, event); // Pass the existing ImageUrl
    }
  };

  const handleDeletePopup = (id, rows, field) => {
    console.log(id, "id");
    let data;
    if (field === "multipleRowInactive") {
      data = rows.map((el) => el.original.ID).join(",");
    } else {
      data = id;
    }
    const deleteRequestParam = {
      id: data,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    setDeleteModalOpen(true);
  };

  const handleManageDataPopup = () => {
    const clearData = { ID: 0, Name: "", TagImageUrl: "" };
    setFormValues(clearData);
  };

  const handleEdit = (row) => {
    console.log(row, "data12");
    setEditModalOpen(true);
    handleUpdate(row.ID);
  };

  const columns = useMemo(() => [
    {
      header: "Tags",
      accessorKey: "Tags",
    },
    {
      header: "Tag Type",
      accessorKey: "TagType",
      // size: 50,
    },
    {
      header: "Description",
      accessorKey: "Description",
      // size: 50,
    },
    {
      header: "Images",
      accessorKey: "TagImageUrl",
      // size: 50,
      Cell: ({ row }) => (
        <a target="_blank" href={row.original.TagImageUrl}>
              <img
                src={row.original.TagImageUrl ? row.original.TagImageUrl : Noimage}
                style={{ maxWidth: "25px", maxHeight: "25px", margin: "2px" }}
              />
            </a>
      ),
    },
    {
      header: "Tag Count",
      accessorKey: "TagCount",
      // size: "20",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            fontWeight: "700",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
          }}
          onClick={() => {
            setRunApi(true);
            setModuleId(row.original.ID);
            setTagName(row.original.Tags);
          }}
        >
          {row.original.TagCount}
        </Box>
      ),
    },
  ]);

  const [columnOrder, setColumnOrder] = useState(
    ["mrt-row-select", ...columns.map((c) => c.accessorKey), "mrt-row-actions"] //array of column ids (Initializing is optional as of v2.10.0)
  );

  const handleEditChange = (event, field) => {
    console.log(event.target.value, "handleChange");

    if (field === "Name") {
      const newdata = {
        ...formValues,
        Name: event.target.value,
      };
      setFormValues(newdata);
    } else if (field === "TagType") {
      const newdata = {
        ...formValues,
        TagType: event.target.value,
      };
      setFormValues(newdata);
    }
    else if (field === "Description") {
      const newdata = {
        ...formValues,
        Description: event.target.value,
      };
      setFormValues(newdata);
    }
  };

  const renderRowActions = ({ row }) => {
    const { original } = row;
    return (
      <div>
        {checkUserPermission(PERMISSION_EDIT) && original.IsDefault === 0 && (
          <button
            className="btn btn-primary btn-md me-2 mt-1 mb-1 ms-1"
            key="edit"
            onClick={() => handleEdit(original)}
          >
            Edit
          </button>
        )}
        {checkUserPermission(PERMISSION_DELETE) && original.IsDefault === 0 && (
          <button
            className="btn btn-dark btn-md mt-1 mb-1 me-2"
            title="Delete"
            data-bs-toggle="modal"
            data-bs-target="#DeleteConfirmationModal"
            onClick={() => handleDeletePopup(original.ID, "", "")}
          >
            Delete
          </button>
        )}
      </div>
    );
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb" style={{ marginLeft: "11px" }}>
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Manage Tags</li>
              </ul>
            </div>
          </div>
          <div className="d-flex justify-content-between mb-3">
            <div className="col-md-4">
              {rowSelectData?.length > 0 && (
                <button
                  className="btn btn-dark btn-sm mt-1"
                  onClick={() =>
                    handleDeletePopup(rowSelectData.join(","), "", "")
                  }
                >
                  Delete Selected
                </button>
              )}
            </div>
            <div className="col-md-4"></div>
            <div className="page-btn">
              {checkUserPermission(PERMISSION_ADD) ? (
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#ManageDataModal"
                  data-backdrop="static"
                  data-keyboard="false"
                  className="btn btn-primary btn-sm pull-right"
                  style={{ width: "max-content" }}
                  onClick={() => handleManageDataPopup()}
                >
                  <i className="fa fa-plus me-2 lg"></i>Add Tag
                </Link>
              ) : (
                ""
              )}
            </div>
          </div>

          <div className="card">
            <div className="card-body" style={{ padding: "0px 20px 0 20px" }}>
              <div className="card-body pb-0">
                <div className="table-responsive">
                  <CommonMatrialReactTable
                    columns={columns}
                    data={data}
                    hodiExport={false}
                    enableRowSelection={(row) =>
                      row.original.IsDefault > 0 ? false : true
                    }
                    enableRowActions={true}
                    renderRowActions={renderRowActions}
                    isRowSelectionManual={true}
                    setRowSelectData={setRowSelection}
                    setColumnOrder={setColumnOrder}
                    state={{ columnOrder, rowSelection }}
                    columnsToExport={["ID","Tags", "TagType", "Description", "TagImageUrl", "TagCount"]}
                  />{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Dialog open={editModalOpen}>
        <DialogTitle textAlign="center">Tags</DialogTitle>
        <DialogContent>
          <div className="modal-body">
            <Formik
              {...props}
              initialValues={formValues}
              validationSchema={validationSchema}
              onSubmit={handlesubmit1}
              enableReinitialize
            >
              {({ values, errors, touched, handleChange, handleBlur }) => (
                <Form>
                  <div className="row">
                    <div className="col-12">
                      <Field
                        type="hidden"
                        className="form-control"
                        id="ID"
                        name="ID"
                        value={values.ID}
                      />
                      <div className="custom-search-select">
                        <label className="col-form-label p-lg-medium">
                          Tag Name
                        </label>
                        <Field
                          type="text"
                          name="Name"
                          className={` ${
                            errors.Name ? "is-invalid" : ""
                          } form-control form-control-sm`}
                          placeholder="Enter Tag Name"
                          value={formValues.Name}
                          onBlur={handleBlur}
                          onChange={(event) => handleEditChange(event, "Name")}
                        />
                        <div className="invalid-feedback">
                          {touched.Name && errors.Name ? errors.Name : ""}
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="custom-search-select">
                        <label className="col-form-label p-lg-medium">
                          Tag Types
                        </label>
                        <Select
                          options={options}
                          value={selectedOption}
                          styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                          onChange={(event) =>
                            setSelectedOption(event, "TagType")
                          }
                        />
                      </div>
                    </div>
                    <div className="custom-search-select">
                      <label className="col-form-label p-lg-medium">
                        Tag Description
                      </label>
                      <Field
                        type="text"
                        name="Description"
                        className="form-control form-control-sm"
                        placeholder="Description..."
                        value={formValues.Description}
                        onBlur={handleBlur}
                        onChange={(event) => handleEditChange(event, "Description")}
                      />
                      <div className="invalid-feedback">
                        {touched.Name && errors.Name ? errors.Name : ""}
                      </div>
                    </div>
                    <div className="col-12">
                      <label className="col-form-label col-md-3 col-form-label p-lg-medium">
                        Tag Image
                      </label>
                      <div className="">
                        <input
                          type="file"
                          onChange={(e) => _handleFileChange(e)}
                          name="Imagename"
                          className="form-control form-control-sm"
                        />
                      </div>
                    </div>
                    {(previewImage || ImageUrl) && (
                      <div className="row mb-3">
                        <div className="col-md-3"></div>
                        <div className="col-md-9">
                          <img
                            src={previewImage || ImageUrl}
                            alt="Category Image Preview"
                            className="ImagePreviewSize"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </DialogContent>
        <DialogActions sx={{ p: "1.25rem" }}>
          <Button
            class="btn btn-sm btn-outline-dark"
            onClick={() => setEditModalOpen(false)}
          >
            Cancel
          </Button>
          <Button
            class="btn btn-sm btn-primary"
            onClick={() => handlesubmit1()}
            variant="contained"
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
      <div
        className="modal fade"
        id="ManageDataModal"
        tabIndex={-1}
        aria-labelledby="upset"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-md modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="p-medium">Manage Tag</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                {" "}
                <span aria-hidden="true">×</span>{" "}
              </button>
            </div>
            <div className="modal-body">
              <Formik
                {...props}
                initialValues={formValues}
                validationSchema={validationSchema}
                onSubmit={handlesubmit1}
                enableReinitialize
              >
                {({ values, errors, touched, handleChange, handleBlur }) => (
                  <Form>
                    <div className="row">
                      <div className="col-12">
                        <Field
                          type="hidden"
                          className="form-control"
                          id="ID"
                          name="ID"
                          value={values.ID}
                        />
                        <div className="">
                          <label className="col-form-label p-lg-medium">
                            Tag Name
                          </label>
                          <Field
                            type="text"
                            name="Name"
                            className={` ${
                              errors.Name ? "is-invalid" : ""
                            } form-control form-control-sm`}
                            placeholder="Enter Tag Name"
                            value={formValues.Name}
                            onBlur={handleBlur}
                            onChange={(event) =>
                              handleEditChange(event, "Name")
                            }
                          />
                          <div className="invalid-feedback">
                            {touched.Name && errors.Name ? errors.Name : ""}
                          </div>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="">
                          <label className="col-form-label p-lg-medium">
                            Tag Types
                          </label>
                          <Select
                            options={options}
                            value={selectedOption}
                            styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                            className="custom-search-select"
                            onChange={(event) =>
                              setSelectedOption(event, "TagType")
                            }
                          />
                        </div>
                      </div>
                      <div className="">
                          <label className="col-form-label p-lg-medium mt-1">
                            Tag Description
                          </label>
                          <Field
                            type="text"
                            name="Descri[tion"
                            className="form-control form-control-sm"
                            placeholder="Description..."
                            value={formValues.tagDescription}
                            onBlur={handleBlur}
                            onChange={(event) =>
                              handleEditChange(event, "Description")
                            }
                          />
                        </div>
                      <div className="col-12">
                        <label className="col-form-label col-md-3 col-form-label p-lg-medium mt-1">
                          Tag Image
                        </label>
                        <div className="">
                          <input
                            type="file"
                            onChange={(e) => _handleFileChange(e)}
                            name="Imagename"
                            className="form-control form-control-sm"
                          />
                        </div>
                      </div>
                      {(previewImage || ImageUrl) && (
                        <div className="row mb-3">
                          <div className="col-md-3"></div>
                          <div className="col-md-9">
                            <img
                              src={previewImage || ImageUrl}
                              alt="Category Image Preview"
                              className="ImagePreviewSize"
                            />
                          </div>
                        </div>
                      )}

                      <div className="col-lg-12 justify-content-right mt-2">
                        <button
                          type="submit"
                          className="btn btn-primary btn-md me-1"
                        >
                          {" "}
                          Submit{" "}
                        </button>
                        <Link
                          to="#"
                          className="btn btn-dark btn-md me-1"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </Link>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Model  */}
      <DeleteConfirmationModal
        deleteApiUrl={`${config.tagBaseUrl}/tags/delete`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />

      <InventorySubModulesRecordsModal
        Module="Tag"
        runApi={runApi}
        closepopup={() => {
          setRunApi(false);
          setModuleId(0);
          handleListData();
        }}
        ModuleId={moduleID}
        Name={tagName}
        columnsToExport={["Item", "Name", "ImageName", "CreatedDate", "ItemId", "ItemVariationId", "TagID", "Tag", ]}
      />
    </>
  );
};

export default Tags;
